import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import filters from './filters/index'
import titleMixin from "./mixin/title_mixin";
import ToastPlugin from "vue-toast-notification";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GoogleSignInPlugin from "vue3-google-signin";
import 'primeicons/primeicons.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';

const app = createApp(App);
app.mixin(titleMixin);

app.component("FontAwesomeIcon", FontAwesomeIcon);

// Only register the Google sign-in plugin when a client ID is configured —
// it throws on init with an empty clientId. The auth pages already hide the
// "Continue with Google" buttons when this env var is blank.
const googleClientId = process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID;
if (googleClientId) {
  app.use(GoogleSignInPlugin, { clientId: googleClientId });
}

app
  .use(ToastPlugin)
  .use(store)
  .use(router)
  .mount("#app");

app.config.globalProperties.$filters = filters
